import { render, staticRenderFns } from "./radio-group.vue?vue&type=template&id=4a20f20c"
import script from "./radio-group.vue?vue&type=script&setup=true&lang=js"
export * from "./radio-group.vue?vue&type=script&setup=true&lang=js"
import style0 from "./radio-group.vue?vue&type=style&index=0&id=4a20f20c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_qhqm3mauky62uixplfzayyuc5e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports